import baseApi from '@/modules/services/base';
import { RepositionEntityType } from '../types/helper';
import { QuestionDataType, QuestionPostType } from '../types/question';
import { QuestionTag, QuestionsTag } from './tags';

interface RepositionQuestionQueryType {
  quizId: string;
  questionPositions: RepositionEntityType[];
}

interface submitAnswerPayloadType {
  answer?: any;
  multiAnswer?: any;
  questionId: string;
  questionMetadata: any;
}

interface updateResult {
  generatedMaps: any[];
  raw: any[];
  affected: number;
}

const questionsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getQuestions: build.query<QuestionDataType[], { quizId: string }>({
      query: (param) => `questions?quiz-id=${param.quizId}`,
      providesTags: [QuestionsTag],
    }),
    getQuestion: build.query<QuestionDataType, { questionId: string }>({
      query: (param) => `questions/${param.questionId}`,
      providesTags: [QuestionTag],
    }),
    createQuestion: build.mutation<
      QuestionPostType,
      { id: string; content: QuestionPostType }
    >({
      query: (body) => ({
        url: `questions/${body.id}`,
        method: 'POST',
        body: body.content,
      }),
      invalidatesTags: [QuestionsTag],
    }),
    updateQuestion: build.mutation<
      updateResult,
      { id: string; content: QuestionPostType }
    >({
      query: (body) => ({
        url: `questions/${body.id}`,
        method: 'PUT',
        body: body.content,
      }),
      invalidatesTags: [QuestionsTag, QuestionTag],
    }),
    deleteQuestion: build.mutation<any, string>({
      query: (id) => ({
        url: `questions/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [QuestionsTag, QuestionTag],
    }),
    submitAnswer: build.mutation<any, { payload: submitAnswerPayloadType }>({
      query: ({ payload }) => ({
        url: `/questions/${payload.questionId}/answers`,
        method: 'POST',
        body: payload,
      }),
    }),
    repositionQuestion: build.mutation<any, RepositionQuestionQueryType>({
      query(payload) {
        return {
          url: `quizzes/${payload.quizId}/questions/position`,
          method: 'POST',
          body: payload.questionPositions,
        };
      },
      invalidatesTags: [QuestionsTag, QuestionTag],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetQuestionsQuery,
  useGetQuestionQuery,
  useCreateQuestionMutation,
  useUpdateQuestionMutation,
  useDeleteQuestionMutation,
  useSubmitAnswerMutation,
  useRepositionQuestionMutation,
} = questionsApi;

export default questionsApi;
